import createIcon from '../../createIcon';

/**
 * @component @name Museum
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTFWOUwxMiAyTDIgOVYxMUg0VjIwSDJWMjJIMjJWMjBIMjBWMTFIMjJaTTE2IDE4SDE0VjE0TDEyIDE3TDEwIDE0VjE4SDhWMTFIMTBMMTIgMTRMMTQgMTFIMTZWMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Museum = createIcon('Museum', [
  [
    'path',
    {
      d: 'M22 11V9L12 2L2 9V11H4V20H2V22H22V20H20V11H22ZM16 18H14V14L12 17L10 14V18H8V11H10L12 14L14 11H16V18Z',
      key: '7kmvyx',
    },
  ],
]);

export default Museum;
